import {Fragment, useContext} from 'react';

import LoginContext from '../../../../../store/login-context';
import classes from './UpdateAnswers.module.scss';

declare function Translate(key: string): string;

const UpdateAnswers = (props) => {
    const ctx = useContext(LoginContext);

    const onUpdateAnswersHandler = () => {
        props.onLinkClick();
    }
    
    const onUpdateAnswersPress = (event) => {
        event.preventDefault();
        if (event.charCode === 13 || event.charCode === 32){
            onUpdateAnswersHandler();
        }
    };

    return (
        <Fragment>
            <div className={classes.update_answers_container}>
                <a id='updateAnswers' 
                    className={classes.update_answers_link} 
                    onClick={onUpdateAnswersHandler}
                    onKeyPress={onUpdateAnswersPress}
                    tabIndex={0}               
                    >
                    {Translate('N_Pre_Reg_Update_Options')}
                </a>
            </div>     
        </Fragment>
    );

};
export default UpdateAnswers;